import React, { useState } from "react";
import { IconButton, ListItem,  ListItemText, List, Dialog, Paper, Typography, Stack } from '@mui/material';
import RecallsFull from "./recalls-full";
import SendIcon from '@mui/icons-material/Send';
import HideSourceIcon from '@mui/icons-material/HideSource';
import AddIcon from '@mui/icons-material/Add';

const RecallsCard = (props) => {
    
var {subject, size, summary, nhtsaCampaignNumber, associatedDocumentsCount, associatedProductsCount, manufacturer} = props;

const [open, setOpen] = useState(false);

const handleClose = () =>{
    setOpen(false);
}

return (
    <List
        sx={{
            margin: 0,
            padding: 0,
            width: '100%',
            borderRadius: 2,
            borderColor: 'divider',
            backgroundColor: 'background.paper',
        }}
    >

        
        <ListItem>
            <ListItemText primary={subject} secondary= {`${summary?.substr(0, 150)}...`} />
        </ListItem>
        <ListItem>
            <ListItemText primary="Nhtsa Campaign Number" secondary= {`${nhtsaCampaignNumber}`} />
            <ListItemText primary="Associated Documents" secondary= {`${associatedDocumentsCount}`} />
            <ListItemText primary="Affected Products" secondary= {`${associatedProductsCount}`} />
            <ListItemText primary="Manufacturer" secondary= {`${manufacturer}`} />
            {/* <Stack
                sx={{
                    

                    width: 100,
                    height: 30,

                    borderRadius: 1,
                    bgcolor: 'warning.main',
                    '&:hover': {
                        bgcolor: 'warning.dark',
                },
                }}
                display={'flex'}
                alignItems={'center'}
                justifyContent={"center"}
            >
                <Typography variant="body">showing</Typography>
            </Stack> */}
            {/* <IconButton onClick={()=>setOpen(true)} variant="contained" color="primary"><AddIcon /></IconButton> */}
            <IconButton onClick={()=>setOpen(true)} variant="contained" color="primary"><SendIcon /></IconButton>
        </ListItem>

        <Dialog
            fullScreen
            open={open}
            onClose={handleClose}
        >
            <RecallsFull {...{...props, setOpen: setOpen}}/>
        </Dialog>
    </List>
)}

export default RecallsCard;